import React from "react"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import NextImage from "next/image"

const EmptyProduct = () => {
  return (
    <Stack
      paddingY="80px"
      width="100%"
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={2}
    >
      <Box
        sx={{
          width: 240,
          height: 240,
          position: "relative",
          overflow: "hidden"
        }}
      >
        <NextImage
          src="/assets/images/empty-sale.png"
          width={240}
          height={240}
          alt="Empty products"
        />
      </Box>

      <Typography variant="body1" sx={{ textAlign: "center", fontWeight: 700 }}>
        Chưa có sản phẩm nào trong danh mục này
      </Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        Chúng tôi sẽ cập nhật sớm nhất có thể để bạn có thể lựa chọn sản phẩm
        phù hợp nhất với nhu cầu của mình
      </Typography>
    </Stack>
  )
}

export default EmptyProduct
